/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_P3_TitleInputs */

const es_cap_p3_title = /** @type {(inputs: Cap_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú decides cada salida`)
};

const gl_cap_p3_title = /** @type {(inputs: Cap_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti decides cada saída`)
};

const en_cap_p3_title = /** @type {(inputs: Cap_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You decide every trip`)
};

/**
* | output |
* | --- |
* | "You decide every trip" |
*
* @param {Cap_P3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_p3_title = /** @type {((inputs?: Cap_P3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_P3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_p3_title(inputs)
	if (locale === "en") return en_cap_p3_title(inputs)
	return es_cap_p3_title(inputs)
});